<template>
	<div class="graph">
		<template v-if="food === 'health'">
			<ScaleTabs
			v-bind:scale="scale"
			:scales="scales"
			@change="setScale"></ScaleTabs>
			<DatePicker
				v-bind:date="date"
				v-bind:startDate="startDate"
				@previous="previous"
				@next="next"></DatePicker>
			<FoodGraph1D
				v-bind:data="foodData"
				v-bind:startDate="startDate"
				v-bind:date="date"
				v-bind:interval="interval"
				v-bind:binWidth="binWidth">
			</FoodGraph1D>
		</template>
        <template v-else>
			<el-row>
				<el-col :span="19">
					<NutritionGraph2D
						:data="sortedData"
						></NutritionGraph2D>
				</el-col>
				<el-col :span="5">
					<NutritionLegend
						:data="sortedData"
						:graph-info="graphInfo"
						></NutritionLegend>
				</el-col>
			</el-row>
		</template>
	</div>
</template>

<script>
import Graph from './index'

const GRAPHINFO = {
	energy: {
		name: 'Calories',
		unit: 'cal',
		color: '#2d3e4f'
	},
	fat: {
		name: 'Fat',
		unit: 'g',
		color: '#5fbfe6'
	},
	carbohydrates: {
		name: 'Carbs',
		unit: 'g',
		color: '#ea895a'
	},
	protein: {
		name: 'Protein',
		unit: 'g',
		color: '#c27fff'
	}
}

export default {
	name: 'food-graph',
	extends: Graph,
	props: {
		/**
		 * Defines type of graph
		 * 
		 * @values `energy`, `health`
		 */
		food: {
			type: String,
			default: 'health'
		},
		averageEnergy: {
			type: Number
		}
	},

	data() {
		return {
			graphInfo: GRAPHINFO
		} 
	},

	computed: {
		/**
		 * @function 	foodData
		 * @desc		Returns the food data with its time, health, component, portion, description
		 */
		foodData() {
			return this.data.map((food) => {
				let point

				// Adding time
				if (food.date_time)
					point = { time: food.date_time }
				else
					point = { time: food.created }

				if (food.meal.toLowerCase().trim() == 'beverage') {
					point.type = 'beverage'

					// Adding the quantity
					if(food.portion_size)
						point.portion = this.sizeValue(food.portion_size)

					// Adding the component
					if(food.component)
						point.component = food.component

					// Adding the description
					if(food.description)
						point.description = food.description
				}
				else {
					point.type = 'food'

					// Adding the desc
					if(food.description)
						point.description = food.description

					// Adding health_perception
					if(food.health_perception)
						point.health = this.healthValue(food.health_perception)

					// Adding the quantity
					if(food.portion_size)
						point.portion = this.sizeValue(food.portion_size)
				}

				return point
			})
		},
		sortedData() {
			return this.data.slice().sort((a, b) => a.time - b.time)
		}
	},

	methods: {
		healthValue(health_perception) {
			health_perception = health_perception.toLowerCase().trim()

			if (health_perception == 'not healthy')
				return 1
			else if (health_perception == 'somewhat healthy')
				return 2
			else if (health_perception == 'very healthy')
				return 3
		},
		sizeValue(text) {
			text = text.toLowerCase().trim()

			if (text == 'small')
				return 1
			else if (text == 'medium')
				return 2
			else if (text == 'large')
				return 3
		}
	}
}
</script>
